import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import styles from './PhotoPrintsGroupWindowNavigation.module.scss';

export const PhotoPrintsGroupWindowNavigation = ({ photoIds, browse, close }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={styles.container}>
            {photoIds.length > 0 ? (
                <Button style='outline' onClick={browse}>
                    {t('photo_prints.add_more')}
                </Button>
            ) : (
                <Button style='outline' onClick={browse}>
                    {t('photo_prints.add')}
                </Button>
            )}

            <Button onClick={close}>
                {t('commons.save')}
            </Button>

        </div>
    );
};

type Props = {
    photoIds: string[];
    browse: () => void;
    close: () => void;
};